import styled from "styled-components";

export const MainBarWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
`;

export const AppTitle = styled.div`
    font-size: 16px;
    // font-weight: 700;
`;
